import * as React from 'react'
import * as PropTypes from 'prop-types'
import { graphql } from "gatsby"

import Layout from "./../../components/layout"
import SEO from "./../../components/seo";
import { Helmet } from "react-helmet"


import { saInterfaceApprentice } from "./../../components/saComponents/saTypes"
import SaFaqContainer from "./../../components/saComponents/saFAQ/saFaqContainer"
import { SaHomeImageFaqContainer } from "./../../components/saComponents/saHomeImageFaq/saHomeImageFaqContainer"
import { SaDefaultImageTextContainer } from "./../../components/saComponents/saHomeImageText/saDefaultImageTextContainer"
import { SaSteps } from "./../../components/saComponents/saSteps/saSteps"
import { SaTestimonialsContainer } from "./../../components/saComponents/saTestimonials/saTestimonialsContainer"
import { SaLogosGallery } from "./../../components/saComponents/saLogosGallery/saLogosGallery"
import { SaBoxes2Container } from "./../../components/saComponents/saBoxes2/saBoxes2Container"
import { SaDefaultSectionContainer } from "./../../components/saComponents/saDefaultSection/saDefaultSectionContainer"
import { SaExpertsContainer } from "./../../components/saComponents/saExperts/saExpertsContainer"
import { SaDefaultHeaderContainer } from "./../../components/saComponents/saDefaultHeader/saDefaultHeaderContainer"




const ApprenticePage = ({ data }) => {
  const page = data.wpPage;


  const Apprentice: React.FC<saInterfaceApprentice> = ({...props}) => {

    const apprentice = props.saApprentice.apprenticeGroup

    return (
      <>

        {
          /* Section 1 */
          apprentice.showSection1 && apprentice.section1 && <SaDefaultHeaderContainer {...apprentice.section1} />
        }

        {
          /* Section 2  */
          apprentice.showSection2 && apprentice.section2 && <SaHomeImageFaqContainer {...apprentice.section2} />
        }


        {
          /* Section 3 */
          apprentice.showSection3 && apprentice.section3 && <SaSteps {...apprentice.section3} />
        }


        {
          /* Section 4 */
          apprentice.showSection4 && apprentice.section4 && <SaDefaultImageTextContainer {...apprentice.section4} />
        }


        {
          /* Section 5 */
          apprentice.showSection5 && apprentice.section5 && <SaExpertsContainer {...apprentice.section5} />
        }


        {
          /* Section 6 */
          apprentice.showSection6 && apprentice.section6 && <SaLogosGallery {...apprentice.section6} />
        }


        {
          /* Section 7 */
          apprentice.showSection7 && apprentice.section7 && <SaTestimonialsContainer {...apprentice.section7} />
        }


        {
          /* Section 8 */
          apprentice.showSection8 && apprentice.section8 && <SaBoxes2Container {...apprentice.section8} />
        }



        {
          /* Section 9 */
          apprentice.showSection9 && apprentice.section9 && <SaDefaultSectionContainer {...apprentice.section9} />
        }


        {
          /* Section 10 - FAQ */
          apprentice.showSection10 && apprentice.section10 && <SaFaqContainer {...apprentice.section10} />
        }

      </>
    )
  }


  return(
    <>
      <Layout>
        <Helmet>
          <body className='apprentice-page' />
        </Helmet>


        <SEO
          title={page.metaMain.title && page.metaMain.title}
          description={page.metaMain.description && page.metaMain.description}
          //ogimage={page.metaMain.ogimage && page.metaMain.ogimage}
        />


        { page.saApprentice && <Apprentice { ...page } /> }


      </Layout>
    </>
  )
}

export default ApprenticePage


ApprenticePage.propTypes = {
  data: PropTypes.shape({
    wpPage: PropTypes.object
  })
}

export const ApprenticePageQuery = graphql`
  query ApprenticePageQuery($id: Int!) {
    wpPage(databaseId: {eq: $id}) {
      title
      uri  
      metaMain {
        title
        description
        ogimage {
          sourceUrl
        }
      }
      saApprentice {
        apprenticeGroup {
          section1 {
            title
            text
            image {
              sourceUrl
              srcSet
              localFile {
                      childImageSharp {
                        gatsbyImageData(
                          formats: [AUTO, WEBP]
                          quality: 100
                          placeholder: NONE
                          backgroundColor: "transparent"
                        )
                      } 
                    }   
            } 
            button {
              show
              title
              link
            } 
          }
          section2 {
            image {
              sourceUrl
              srcSet
              localFile {
                      childImageSharp {
                        gatsbyImageData(
                          formats: [AUTO, WEBP]
                          quality: 100
                          placeholder: NONE
                          backgroundColor: "transparent"
                        )
                      } 
                    }   
            } 
            icon
            title
            text
          }
          section3 {
            steps {
              text
            }
          }
          section4 {
            image {
              sourceUrl
              srcSet
              localFile {
                      childImageSharp {
                        gatsbyImageData(
                          formats: [AUTO, WEBP]
                          quality: 100
                          placeholder: NONE
                          backgroundColor: "transparent"
                        )
                      } 
                    }   
            } 
            sectionTitle
            text
            title
          }
          section5 {
            sectionTitle
            text 
            relationship {
              __typename
              ... on WpExpert {      
                title        
                saExpertDetails {
                  expertDetails {
                    photo  {
                      sourceUrl
                      srcSet
                      localFile {
                              childImageSharp {
                                gatsbyImageData(
                                  formats: [AUTO, WEBP]
                                  quality: 100
                                  placeholder: NONE
                                  backgroundColor: "transparent"
                                )
                              } 
                            }   
                    } 
                    logo  {
                      sourceUrl
                      srcSet
                      localFile {
                              childImageSharp {
                                gatsbyImageData(
                                  formats: [AUTO, WEBP]
                                  quality: 100
                                  placeholder: NONE
                                  backgroundColor: "transparent"
                                )
                              } 
                            }   
                    } 
                    position
                  }
                }
              }
            }
          }
          section6 {
            sectionTitle
            logos {
              image {
                sourceUrl
                srcSet
                localFile {
                        childImageSharp {
                          gatsbyImageData(
                            formats: [AUTO, WEBP]
                            quality: 100
                            placeholder: NONE
                            backgroundColor: "transparent"
                          )
                        } 
                      }  
              }
            }
          }
          section7 {
            title
            text
            relationship {
              ... on WpTestimonial {
                id  
                title
                content
                testimonialsPosts {
                  details {
                    image {
                      srcSet
                      sourceUrl
                      localFile {
                        childImageSharp {
                          gatsbyImageData( 
                            formats: [AUTO, WEBP, PNG]
                            quality: 100
                            placeholder: NONE
                            backgroundColor: "transparent"
                          )
                        }  
                      }
                    }
                    position
                  } 
                } 
              }
            }
            image {
                sourceUrl
                srcSet
                localFile {
                        childImageSharp {
                          gatsbyImageData(
                            formats: [AUTO, WEBP]
                            quality: 100
                            placeholder: NONE
                            backgroundColor: "transparent"
                          )
                        } 
                      }  
              }
          }
          section8 {
            title
            text
            blocks {
              title
              text
              icon
            }
          }
          section9 {
            title
            text
            image {
                sourceUrl
                srcSet
                localFile {
                        childImageSharp {
                          gatsbyImageData(
                            formats: [AUTO, WEBP]
                            quality: 100
                            placeholder: NONE
                            backgroundColor: "transparent"
                          )
                        } 
                      }  
              }
            button {
              title
              show
              link
            }
          }
          section10 {
            faq {
              a
              q
            }
            sectionTitle
            text
          }
          showSection1
          showSection2
          showSection4
          showSection3
          showSection5
          showSection6
          showSection7
          showSection8
          showSection9
          showSection10
        }
      }     
    } 
  }
`